import rp, { CodeEditorAdapter, CodeEditorOptions } from "@reporting/rp-app-host";
import { msg } from "@omegagrid/localize";

/**
 * JSON editor of the raw highcharts options (view_options.highchart_options)
 * merged over the generated chart options as the last step before rendering.
 * The view options are read through a callback - the editor works on the
 * live working copy of its visualization editor.
 */
export class HighchartOptionsCodeEditorAdapter extends CodeEditorAdapter {

	constructor(
		private getViewOptions: () => Record<string, any>,
		private applyChange: () => void,
	) { super() }

	getContent(): string {
		const options = this.getViewOptions()?.highchart_options;
		return options ? JSON.stringify(options, null, '\t') : '{}';
	}

	/**
	 * Parse and store the options, refresh the live preview. Returns false in
	 * every case: the change tracking runs through the edit event dispatched
	 * by applyChange, the save event of the code editor would mark the whole
	 * report as saved.
	 */
	save(content: string): boolean {
		const viewOptions = this.getViewOptions();
		if (!viewOptions) return false;

		let parsed: Record<string, any>;
		try {
			parsed = content.trim() ? JSON.parse(content) : null;
		} catch (e) {
			rp.host.showAlert({content: `${msg('Invalid JSON')}: ${(e as Error).message}`, type: 'danger'});
			return false;
		}

		if (parsed && Object.keys(parsed).length) {
			viewOptions.highchart_options = parsed;
		} else {
			delete viewOptions.highchart_options;
		}

		this.applyChange();
		return false;
	}

	getOptions(): CodeEditorOptions {
		return this.createOptions({
			language: 'json',
		});
	}

}
